/**
 * 域名替换工具
 * 根据当前页面访问域名，动态替换非静态资源URL的域名
 */
(function () {
  // 需要被替换的域名后缀列表
  var REPLACEABLE_SUFFIXES = ['kouyujie.cn', 'speakstreet.cn']
  // 目标域名
  var TARGET_DOMAIN = 'ququkid.com'
  // 特殊域名映射：特定原域名 → 特定目标域名（优先级高于通用替换规则）
  var SPECIAL_DOMAIN_MAP = {
    'hellokid.speakstreet.cn': 'student.ququkid.com'
  }
  // 静态媒体资源域名（不进行域名替换）
  var STATIC_MEDIA_DOMAINS = ['medias.kouyujie.cn', 'oss.kouyujie.cn', 'imgs.kouyujie.cn', 'imgs.speakstreet.cn']

  /**
   * 检测当前页面域名是否包含 ququkid.com
   */
  function isQuqukidDomain () {
    try {
      return window.location.hostname.indexOf(TARGET_DOMAIN) !== -1
    } catch (e) {
      return false
    }
  }

  /**
   * 从 URL 中提取 hostname
   */
  function extractHostname (url) {
    var match = url.match(/^https?:\/\/([^/:?#]+)/i)
    return match ? match[1] : null
  }

  /**
   * 判断 hostname 是否需要被替换（是否以已知后缀结尾）
   */
  function getReplaceableSuffix (hostname) {
    // 如果已经是 ququkid.com，不需要替换
    if (hostname.indexOf(TARGET_DOMAIN) !== -1) {
      return null
    }
    for (var i = 0; i < REPLACEABLE_SUFFIXES.length; i++) {
      if (hostname.indexOf(REPLACEABLE_SUFFIXES[i]) !== -1) {
        return REPLACEABLE_SUFFIXES[i]
      }
    }
    return null
  }

  /**
   * 替换 URL 中的域名
   * @param {string} url - 原始URL
   * @returns {string} 替换后的URL
   *
   * 规则：保持子域名不变，替换主域名（最后2段 .分隔）为 ququkid.com
   * 例如：
   *   hellokid.speakstreet.cn/path → hellokid.ququkid.com/path
   *   medias.kouyujie.cn/path    → medias.ququkid.com/path
   *   backend-bops.kouyujie.cn   → backend-bops.ququkid.com
   */
  function replaceDomain (url) {
    if (!url || typeof url !== 'string') {
      return url
    }

    // 只在 ququkid.com 域名下才进行域名替换，kouyujie.cn 访问时保持原样（dubai 租户）
    if (!isQuqukidDomain()) {
      return url
    }

    // 只处理完整的 http(s) URL
    if (url.indexOf('http://') !== 0 && url.indexOf('https://') !== 0) {
      return url
    }

    var hostname = extractHostname(url)
    if (!hostname) {
      return url
    }

    // 静态媒体资源域名不替换
    for (var m = 0; m < STATIC_MEDIA_DOMAINS.length; m++) {
      if (hostname.indexOf(STATIC_MEDIA_DOMAINS[m]) !== -1) {
        return url
      }
    }

    // 先检查特殊域名映射（精确匹配）
    if (SPECIAL_DOMAIN_MAP[hostname]) {
      return url.replace(hostname, SPECIAL_DOMAIN_MAP[hostname])
    }

    var suffix = getReplaceableSuffix(hostname)
    if (!suffix) {
      return url
    }

    // 计算后缀的段数（如 kouyujie.cn = 2段）
    var suffixParts = suffix.split('.')
    var suffixLength = suffixParts.length

    // 将 hostname 按 . 分割
    var parts = hostname.split('.')

    // 替换最后 suffixLength 段为 TARGET_DOMAIN 的各段
    var targetParts = TARGET_DOMAIN.split('.')
    var newParts = parts.slice(0, parts.length - suffixLength).concat(targetParts)
    var newHostname = newParts.join('.')

    return url.replace(hostname, newHostname)
  }

  /**
   * 添加可替换的域名后缀（供外部动态注册，如从 apiBaseUrl 提取）
   */
  function addReplaceableSuffix (suffix) {
    if (suffix && REPLACEABLE_SUFFIXES.indexOf(suffix) === -1) {
      REPLACEABLE_SUFFIXES.push(suffix)
    }
  }

  var domainHelper = {
    isQuqukidDomain: isQuqukidDomain,
    replaceDomain: replaceDomain,
    addReplaceableSuffix: addReplaceableSuffix
  }

  // CommonJS 导出
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = domainHelper
  }

  // 同时也挂到 window，方便非模块化场景使用
  window.$domainHelper = domainHelper
})()



// WEBPACK FOOTER //
// ./src/tools/domainHelper.js